<template>
  <div class="c-audio-box mt-1 d-flex align-items-center justify-between">
    <div class="c-audio-box__content">
      <div v-if="!listenLoading" class="c-audio-custom" @click="listen">
        <div class="c-audio-custom__icon"><i class="fa fa-play"></i></div>
        <div class="c-audio-custom__time"> 00:00 / {{ duration | callDuration }}</div>
        <div class="c-audio-custom__bar"><span style="width: 0%;"></span></div>
      </div>
      <audio ref="player" controls :hidden="!listenLoading" style="width: 100%">
        <source :src="recordingUrl" type="audio/mp3"/>
        Your browser does not support the audio element.
      </audio>
    </div>
    <div class="c-audio-box__bar ml-3">
      <a @click="download" target="_blank" style="cursor: pointer">
        <i class="fa fa-download text-primary"></i>
      </a>
<!--      <template v-if="showSkip">-->
<!--        <a @click="download" target="_blank">-->
<!--          <i class="fa fa-fast-forward"></i>-->
<!--        </a>-->
<!--      </template>-->
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ["id", "duration", "log", 'billDuration', 'showSkip'],
  data() {
    return {
      recordingUrl: null,
      listenLoading: false,
      updateLoading: false
    };
  },
  computed: {
    service() {
      let service = `/call/${this.id}/recording`;
      if (this.log) {
        service = `/call/${this.id}/recording-log/${this.log}`;
      }
      return service
    }
  },
  methods: {
    download() {
      if (this.recordingUrl) {
        window.open(this.recordingUrl, "_blank");
      } else {
        this.$service.get(this.service).then(response => {
          window.open(response.data.url, "_blank");
        });
      }

    },
    listen() {
      this.updateLoading = true;
      this.$service.get(this.service).then(response => {
        this.listenLoading = true;
        this.recordingUrl = response.data.url;
        this.$refs.player.load();
        this.$refs.player.play();
      }).catch(error => {
        if (error.response.data.msg) {
          this.$swal({
            text: error.response.data.msg,
            icon: 'error'
          });
        }
      }).finally(() => {
        this.updateLoading = false;
      });

    },
  },
  mounted() {
  }
}
</script>

<style>
@media (min-width: 768px) {
  .c-audio-box__content {
    width: calc(100% - 32px);
  }
}

.c-audio-custom {
  background: #ddd;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 20px;
  padding: 0 10px;
  cursor: pointer;
  min-width: 220px;
  border-radius: 10px;
}

.c-audio-custom__icon {
  width: 17px;
  line-height: 11px;
}

[class*=icon] {
  background-position: center center;
  background-repeat: no-repeat;
  vertical-align: middle;
}

.c-audio-custom__time {
  font-size: 10px;
  width: 65px;
}

.c-audio-custom__bar {
  width: calc(100% - 82px);
  position: relative;
  z-index: 1;
  height: 5px;
  background: #FFF;
  border-radius: 3px;
}

.c-audio-custom__bar span {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  bottom: 0;
  background: linear-gradient(45deg, #4CC8E9, #FF6FBC);
  background: -o-linear-gradient(45deg, #4CC8E9, #FF6FBC);
  border-radius: 3px;
}
</style>